const state = () => ({
  min: null,
  max: null,
})

const actions = {
  setPriceMin({ commit }, value) {
    commit('SET_PRICE_MIN', value)
  },
  setPriceMax({ commit }, value) {
    commit('SET_PRICE_MAX', value)
  },
  clearPrice({ commit }) {
    commit('CLEAR_PRICE')
  },
}

const mutations = {
  SET_PRICE_MIN(state, value) {
    state.min = value
  },
  SET_PRICE_MAX(state, value) {
    state.max = value
  },
  CLEAR_PRICE(state) {
    state.min = null
    state.max = null
  },
}

const getters = {
  getPriceMin: (state) => state.min,
  getPriceMax: (state) => state.max,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
